module.exports = __webpack_public_path__ + "static/media/38.af9bca5f.jpg";